import '../vendor.css';var q = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Nt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function An(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(t, i);
    Object.defineProperty(n, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return t[i];
      }
    });
  }), n;
}
var We = { exports: {} }, $t = { exports: {} }, Vt = { exports: {} };
/*!
  * Bootstrap data.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var ve;
function wn() {
  return ve || (ve = 1, function(t, e) {
    (function(n, i) {
      t.exports = i();
    })(q, function() {
      const n = /* @__PURE__ */ new Map();
      return {
        set(r, s, a) {
          n.has(r) || n.set(r, /* @__PURE__ */ new Map());
          const o = n.get(r);
          if (!o.has(s) && o.size !== 0) {
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(o.keys())[0]}.`);
            return;
          }
          o.set(s, a);
        },
        get(r, s) {
          return n.has(r) && n.get(r).get(s) || null;
        },
        remove(r, s) {
          if (!n.has(r))
            return;
          const a = n.get(r);
          a.delete(s), a.size === 0 && n.delete(r);
        }
      };
    });
  }(Vt)), Vt.exports;
}
var Ft = { exports: {} }, yt = { exports: {} };
/*!
  * Bootstrap index.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var be;
function J() {
  return be || (be = 1, function(t, e) {
    (function(n, i) {
      i(e);
    })(q, function(n) {
      const s = "transitionend", a = (u) => (u && window.CSS && window.CSS.escape && (u = u.replace(/#([^\s"#']+)/g, (v, b) => `#${CSS.escape(b)}`)), u), o = (u) => u == null ? `${u}` : Object.prototype.toString.call(u).match(/\s([a-z]+)/i)[1].toLowerCase(), l = (u) => {
        do
          u += Math.floor(Math.random() * 1e6);
        while (document.getElementById(u));
        return u;
      }, p = (u) => {
        if (!u)
          return 0;
        let {
          transitionDuration: v,
          transitionDelay: b
        } = window.getComputedStyle(u);
        const A = Number.parseFloat(v), S = Number.parseFloat(b);
        return !A && !S ? 0 : (v = v.split(",")[0], b = b.split(",")[0], (Number.parseFloat(v) + Number.parseFloat(b)) * 1e3);
      }, d = (u) => {
        u.dispatchEvent(new Event(s));
      }, y = (u) => !u || typeof u != "object" ? !1 : (typeof u.jquery < "u" && (u = u[0]), typeof u.nodeType < "u"), h = (u) => y(u) ? u.jquery ? u[0] : u : typeof u == "string" && u.length > 0 ? document.querySelector(a(u)) : null, g = (u) => {
        if (!y(u) || u.getClientRects().length === 0)
          return !1;
        const v = getComputedStyle(u).getPropertyValue("visibility") === "visible", b = u.closest("details:not([open])");
        if (!b)
          return v;
        if (b !== u) {
          const A = u.closest("summary");
          if (A && A.parentNode !== b || A === null)
            return !1;
        }
        return v;
      }, N = (u) => !u || u.nodeType !== Node.ELEMENT_NODE || u.classList.contains("disabled") ? !0 : typeof u.disabled < "u" ? u.disabled : u.hasAttribute("disabled") && u.getAttribute("disabled") !== "false", w = (u) => {
        if (!document.documentElement.attachShadow)
          return null;
        if (typeof u.getRootNode == "function") {
          const v = u.getRootNode();
          return v instanceof ShadowRoot ? v : null;
        }
        return u instanceof ShadowRoot ? u : u.parentNode ? w(u.parentNode) : null;
      }, O = () => {
      }, C = (u) => {
        u.offsetHeight;
      }, P = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, R = [], x = (u) => {
        document.readyState === "loading" ? (R.length || document.addEventListener("DOMContentLoaded", () => {
          for (const v of R)
            v();
        }), R.push(u)) : u();
      }, I = () => document.documentElement.dir === "rtl", m = (u) => {
        x(() => {
          const v = P();
          if (v) {
            const b = u.NAME, A = v.fn[b];
            v.fn[b] = u.jQueryInterface, v.fn[b].Constructor = u, v.fn[b].noConflict = () => (v.fn[b] = A, u.jQueryInterface);
          }
        });
      }, _ = (u, v = [], b = u) => typeof u == "function" ? u(...v) : b, T = (u, v, b = !0) => {
        if (!b) {
          _(u);
          return;
        }
        const S = p(v) + 5;
        let L = !1;
        const k = ({
          target: V
        }) => {
          V === v && (L = !0, v.removeEventListener(s, k), _(u));
        };
        v.addEventListener(s, k), setTimeout(() => {
          L || d(v);
        }, S);
      }, D = (u, v, b, A) => {
        const S = u.length;
        let L = u.indexOf(v);
        return L === -1 ? !b && A ? u[S - 1] : u[0] : (L += b ? 1 : -1, A && (L = (L + S) % S), u[Math.max(0, Math.min(L, S - 1))]);
      };
      n.defineJQueryPlugin = m, n.execute = _, n.executeAfterTransition = T, n.findShadowRoot = w, n.getElement = h, n.getNextActiveElement = D, n.getTransitionDurationFromElement = p, n.getUID = l, n.getjQuery = P, n.isDisabled = N, n.isElement = y, n.isRTL = I, n.isVisible = g, n.noop = O, n.onDOMContentLoaded = x, n.parseSelector = a, n.reflow = C, n.toType = o, n.triggerTransitionEnd = d, Object.defineProperty(n, Symbol.toStringTag, { value: "Module" });
    });
  }(yt, yt.exports)), yt.exports;
}
/*!
  * Bootstrap event-handler.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Ee;
function it() {
  return Ee || (Ee = 1, function(t, e) {
    (function(n, i) {
      t.exports = i(J());
    })(q, function(n) {
      const i = /[^.]*(?=\..*)\.|.*/, r = /\..*/, s = /::\d+$/, a = {};
      let o = 1;
      const l = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
      }, p = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
      function d(m, _) {
        return _ && `${_}::${o++}` || m.uidEvent || o++;
      }
      function y(m) {
        const _ = d(m);
        return m.uidEvent = _, a[_] = a[_] || {}, a[_];
      }
      function h(m, _) {
        return function T(D) {
          return I(D, {
            delegateTarget: m
          }), T.oneOff && x.off(m, D.type, _), _.apply(m, [D]);
        };
      }
      function g(m, _, T) {
        return function D(u) {
          const v = m.querySelectorAll(_);
          for (let {
            target: b
          } = u; b && b !== this; b = b.parentNode)
            for (const A of v)
              if (A === b)
                return I(u, {
                  delegateTarget: b
                }), D.oneOff && x.off(m, u.type, _, T), T.apply(b, [u]);
        };
      }
      function N(m, _, T = null) {
        return Object.values(m).find((D) => D.callable === _ && D.delegationSelector === T);
      }
      function w(m, _, T) {
        const D = typeof _ == "string", u = D ? T : _ || T;
        let v = R(m);
        return p.has(v) || (v = m), [D, u, v];
      }
      function O(m, _, T, D, u) {
        if (typeof _ != "string" || !m)
          return;
        let [v, b, A] = w(_, T, D);
        _ in l && (b = ((B) => function(f) {
          if (!f.relatedTarget || f.relatedTarget !== f.delegateTarget && !f.delegateTarget.contains(f.relatedTarget))
            return B.call(this, f);
        })(b));
        const S = y(m), L = S[A] || (S[A] = {}), k = N(L, b, v ? T : null);
        if (k) {
          k.oneOff = k.oneOff && u;
          return;
        }
        const V = d(b, _.replace(i, "")), F = v ? g(m, T, b) : h(m, b);
        F.delegationSelector = v ? T : null, F.callable = b, F.oneOff = u, F.uidEvent = V, L[V] = F, m.addEventListener(A, F, v);
      }
      function C(m, _, T, D, u) {
        const v = N(_[T], D, u);
        v && (m.removeEventListener(T, v, !!u), delete _[T][v.uidEvent]);
      }
      function P(m, _, T, D) {
        const u = _[T] || {};
        for (const [v, b] of Object.entries(u))
          v.includes(D) && C(m, _, T, b.callable, b.delegationSelector);
      }
      function R(m) {
        return m = m.replace(r, ""), l[m] || m;
      }
      const x = {
        on(m, _, T, D) {
          O(m, _, T, D, !1);
        },
        one(m, _, T, D) {
          O(m, _, T, D, !0);
        },
        off(m, _, T, D) {
          if (typeof _ != "string" || !m)
            return;
          const [u, v, b] = w(_, T, D), A = b !== _, S = y(m), L = S[b] || {}, k = _.startsWith(".");
          if (typeof v < "u") {
            if (!Object.keys(L).length)
              return;
            C(m, S, b, v, u ? T : null);
            return;
          }
          if (k)
            for (const V of Object.keys(S))
              P(m, S, V, _.slice(1));
          for (const [V, F] of Object.entries(L)) {
            const $ = V.replace(s, "");
            (!A || _.includes($)) && C(m, S, b, F.callable, F.delegationSelector);
          }
        },
        trigger(m, _, T) {
          if (typeof _ != "string" || !m)
            return null;
          const D = n.getjQuery(), u = R(_), v = _ !== u;
          let b = null, A = !0, S = !0, L = !1;
          v && D && (b = D.Event(_, T), D(m).trigger(b), A = !b.isPropagationStopped(), S = !b.isImmediatePropagationStopped(), L = b.isDefaultPrevented());
          const k = I(new Event(_, {
            bubbles: A,
            cancelable: !0
          }), T);
          return L && k.preventDefault(), S && m.dispatchEvent(k), k.defaultPrevented && b && b.preventDefault(), k;
        }
      };
      function I(m, _ = {}) {
        for (const [T, D] of Object.entries(_))
          try {
            m[T] = D;
          } catch {
            Object.defineProperty(m, T, {
              configurable: !0,
              get() {
                return D;
              }
            });
          }
        return m;
      }
      return x;
    });
  }(Ft)), Ft.exports;
}
var Wt = { exports: {} }, Bt = { exports: {} };
/*!
  * Bootstrap manipulator.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var ye;
function Qt() {
  return ye || (ye = 1, function(t, e) {
    (function(n, i) {
      t.exports = i();
    })(q, function() {
      function n(s) {
        if (s === "true")
          return !0;
        if (s === "false")
          return !1;
        if (s === Number(s).toString())
          return Number(s);
        if (s === "" || s === "null")
          return null;
        if (typeof s != "string")
          return s;
        try {
          return JSON.parse(decodeURIComponent(s));
        } catch {
          return s;
        }
      }
      function i(s) {
        return s.replace(/[A-Z]/g, (a) => `-${a.toLowerCase()}`);
      }
      return {
        setDataAttribute(s, a, o) {
          s.setAttribute(`data-bs-${i(a)}`, o);
        },
        removeDataAttribute(s, a) {
          s.removeAttribute(`data-bs-${i(a)}`);
        },
        getDataAttributes(s) {
          if (!s)
            return {};
          const a = {}, o = Object.keys(s.dataset).filter((l) => l.startsWith("bs") && !l.startsWith("bsConfig"));
          for (const l of o) {
            let p = l.replace(/^bs/, "");
            p = p.charAt(0).toLowerCase() + p.slice(1, p.length), a[p] = n(s.dataset[l]);
          }
          return a;
        },
        getDataAttribute(s, a) {
          return n(s.getAttribute(`data-bs-${i(a)}`));
        }
      };
    });
  }(Bt)), Bt.exports;
}
/*!
  * Bootstrap config.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Ae;
function xt() {
  return Ae || (Ae = 1, function(t, e) {
    (function(n, i) {
      t.exports = i(Qt(), J());
    })(q, function(n, i) {
      class r {
        // Getters
        static get Default() {
          return {};
        }
        static get DefaultType() {
          return {};
        }
        static get NAME() {
          throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(a) {
          return a = this._mergeConfigObj(a), a = this._configAfterMerge(a), this._typeCheckConfig(a), a;
        }
        _configAfterMerge(a) {
          return a;
        }
        _mergeConfigObj(a, o) {
          const l = i.isElement(o) ? n.getDataAttribute(o, "config") : {};
          return {
            ...this.constructor.Default,
            ...typeof l == "object" ? l : {},
            ...i.isElement(o) ? n.getDataAttributes(o) : {},
            ...typeof a == "object" ? a : {}
          };
        }
        _typeCheckConfig(a, o = this.constructor.DefaultType) {
          for (const [l, p] of Object.entries(o)) {
            const d = a[l], y = i.isElement(d) ? "element" : i.toType(d);
            if (!new RegExp(p).test(y))
              throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${l}" provided type "${y}" but expected type "${p}".`);
          }
        }
      }
      return r;
    });
  }(Wt)), Wt.exports;
}
/*!
  * Bootstrap base-component.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var we;
function St() {
  return we || (we = 1, function(t, e) {
    (function(n, i) {
      t.exports = i(wn(), it(), xt(), J());
    })(q, function(n, i, r, s) {
      const a = "5.3.3";
      class o extends r {
        constructor(p, d) {
          super(), p = s.getElement(p), p && (this._element = p, this._config = this._getConfig(d), n.set(this._element, this.constructor.DATA_KEY, this));
        }
        // Public
        dispose() {
          n.remove(this._element, this.constructor.DATA_KEY), i.off(this._element, this.constructor.EVENT_KEY);
          for (const p of Object.getOwnPropertyNames(this))
            this[p] = null;
        }
        _queueCallback(p, d, y = !0) {
          s.executeAfterTransition(p, d, y);
        }
        _getConfig(p) {
          return p = this._mergeConfigObj(p, this._element), p = this._configAfterMerge(p), this._typeCheckConfig(p), p;
        }
        // Static
        static getInstance(p) {
          return n.get(s.getElement(p), this.DATA_KEY);
        }
        static getOrCreateInstance(p, d = {}) {
          return this.getInstance(p) || new this(p, typeof d == "object" ? d : null);
        }
        static get VERSION() {
          return a;
        }
        static get DATA_KEY() {
          return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
          return `.${this.DATA_KEY}`;
        }
        static eventName(p) {
          return `${p}${this.EVENT_KEY}`;
        }
      }
      return o;
    });
  }($t)), $t.exports;
}
var jt = { exports: {} };
/*!
  * Bootstrap selector-engine.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Te;
function ct() {
  return Te || (Te = 1, function(t, e) {
    (function(n, i) {
      t.exports = i(J());
    })(q, function(n) {
      const i = (s) => {
        let a = s.getAttribute("data-bs-target");
        if (!a || a === "#") {
          let o = s.getAttribute("href");
          if (!o || !o.includes("#") && !o.startsWith("."))
            return null;
          o.includes("#") && !o.startsWith("#") && (o = `#${o.split("#")[1]}`), a = o && o !== "#" ? o.trim() : null;
        }
        return a ? a.split(",").map((o) => n.parseSelector(o)).join(",") : null;
      }, r = {
        find(s, a = document.documentElement) {
          return [].concat(...Element.prototype.querySelectorAll.call(a, s));
        },
        findOne(s, a = document.documentElement) {
          return Element.prototype.querySelector.call(a, s);
        },
        children(s, a) {
          return [].concat(...s.children).filter((o) => o.matches(a));
        },
        parents(s, a) {
          const o = [];
          let l = s.parentNode.closest(a);
          for (; l; )
            o.push(l), l = l.parentNode.closest(a);
          return o;
        },
        prev(s, a) {
          let o = s.previousElementSibling;
          for (; o; ) {
            if (o.matches(a))
              return [o];
            o = o.previousElementSibling;
          }
          return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next(s, a) {
          let o = s.nextElementSibling;
          for (; o; ) {
            if (o.matches(a))
              return [o];
            o = o.nextElementSibling;
          }
          return [];
        },
        focusableChildren(s) {
          const a = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((o) => `${o}:not([tabindex^="-"])`).join(",");
          return this.find(a, s).filter((o) => !n.isDisabled(o) && n.isVisible(o));
        },
        getSelectorFromElement(s) {
          const a = i(s);
          return a && r.findOne(a) ? a : null;
        },
        getElementFromSelector(s) {
          const a = i(s);
          return a ? r.findOne(a) : null;
        },
        getMultipleElementsFromSelector(s) {
          const a = i(s);
          return a ? r.find(a) : [];
        }
      };
      return r;
    });
  }(jt)), jt.exports;
}
var qt = { exports: {} };
/*!
  * Bootstrap backdrop.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Oe;
function Tn() {
  return Oe || (Oe = 1, function(t, e) {
    (function(n, i) {
      t.exports = i(it(), xt(), J());
    })(q, function(n, i, r) {
      const s = "backdrop", a = "fade", o = "show", l = `mousedown.bs.${s}`, p = {
        className: "modal-backdrop",
        clickCallback: null,
        isAnimated: !1,
        isVisible: !0,
        // if false, we use the backdrop helper without adding any element to the dom
        rootElement: "body"
        // give the choice to place backdrop under different elements
      }, d = {
        className: "string",
        clickCallback: "(function|null)",
        isAnimated: "boolean",
        isVisible: "boolean",
        rootElement: "(element|string)"
      };
      class y extends i {
        constructor(g) {
          super(), this._config = this._getConfig(g), this._isAppended = !1, this._element = null;
        }
        // Getters
        static get Default() {
          return p;
        }
        static get DefaultType() {
          return d;
        }
        static get NAME() {
          return s;
        }
        // Public
        show(g) {
          if (!this._config.isVisible) {
            r.execute(g);
            return;
          }
          this._append();
          const N = this._getElement();
          this._config.isAnimated && r.reflow(N), N.classList.add(o), this._emulateAnimation(() => {
            r.execute(g);
          });
        }
        hide(g) {
          if (!this._config.isVisible) {
            r.execute(g);
            return;
          }
          this._getElement().classList.remove(o), this._emulateAnimation(() => {
            this.dispose(), r.execute(g);
          });
        }
        dispose() {
          this._isAppended && (n.off(this._element, l), this._element.remove(), this._isAppended = !1);
        }
        // Private
        _getElement() {
          if (!this._element) {
            const g = document.createElement("div");
            g.className = this._config.className, this._config.isAnimated && g.classList.add(a), this._element = g;
          }
          return this._element;
        }
        _configAfterMerge(g) {
          return g.rootElement = r.getElement(g.rootElement), g;
        }
        _append() {
          if (this._isAppended)
            return;
          const g = this._getElement();
          this._config.rootElement.append(g), n.on(g, l, () => {
            r.execute(this._config.clickCallback);
          }), this._isAppended = !0;
        }
        _emulateAnimation(g) {
          r.executeAfterTransition(g, this._getElement(), this._config.isAnimated);
        }
      }
      return y;
    });
  }(qt)), qt.exports;
}
var At = { exports: {} };
/*!
  * Bootstrap component-functions.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Ce;
function On() {
  return Ce || (Ce = 1, function(t, e) {
    (function(n, i) {
      i(e, it(), ct(), J());
    })(q, function(n, i, r, s) {
      const a = (o, l = "hide") => {
        const p = `click.dismiss${o.EVENT_KEY}`, d = o.NAME;
        i.on(document, p, `[data-bs-dismiss="${d}"]`, function(y) {
          if (["A", "AREA"].includes(this.tagName) && y.preventDefault(), s.isDisabled(this))
            return;
          const h = r.getElementFromSelector(this) || this.closest(`.${d}`);
          o.getOrCreateInstance(h)[l]();
        });
      };
      n.enableDismissTrigger = a, Object.defineProperty(n, Symbol.toStringTag, { value: "Module" });
    });
  }(At, At.exports)), At.exports;
}
var Ht = { exports: {} };
/*!
  * Bootstrap focustrap.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var De;
function Cn() {
  return De || (De = 1, function(t, e) {
    (function(n, i) {
      t.exports = i(it(), ct(), xt());
    })(q, function(n, i, r) {
      const s = "focustrap", o = ".bs.focustrap", l = `focusin${o}`, p = `keydown.tab${o}`, d = "Tab", y = "forward", h = "backward", g = {
        autofocus: !0,
        trapElement: null
        // The element to trap focus inside of
      }, N = {
        autofocus: "boolean",
        trapElement: "element"
      };
      class w extends r {
        constructor(C) {
          super(), this._config = this._getConfig(C), this._isActive = !1, this._lastTabNavDirection = null;
        }
        // Getters
        static get Default() {
          return g;
        }
        static get DefaultType() {
          return N;
        }
        static get NAME() {
          return s;
        }
        // Public
        activate() {
          this._isActive || (this._config.autofocus && this._config.trapElement.focus(), n.off(document, o), n.on(document, l, (C) => this._handleFocusin(C)), n.on(document, p, (C) => this._handleKeydown(C)), this._isActive = !0);
        }
        deactivate() {
          this._isActive && (this._isActive = !1, n.off(document, o));
        }
        // Private
        _handleFocusin(C) {
          const {
            trapElement: P
          } = this._config;
          if (C.target === document || C.target === P || P.contains(C.target))
            return;
          const R = i.focusableChildren(P);
          R.length === 0 ? P.focus() : this._lastTabNavDirection === h ? R[R.length - 1].focus() : R[0].focus();
        }
        _handleKeydown(C) {
          C.key === d && (this._lastTabNavDirection = C.shiftKey ? h : y);
        }
      }
      return w;
    });
  }(Ht)), Ht.exports;
}
var Ut = { exports: {} };
/*!
  * Bootstrap scrollbar.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Ne;
function Dn() {
  return Ne || (Ne = 1, function(t, e) {
    (function(n, i) {
      t.exports = i(Qt(), ct(), J());
    })(q, function(n, i, r) {
      const s = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", a = ".sticky-top", o = "padding-right", l = "margin-right";
      class p {
        constructor() {
          this._element = document.body;
        }
        // Public
        getWidth() {
          const y = document.documentElement.clientWidth;
          return Math.abs(window.innerWidth - y);
        }
        hide() {
          const y = this.getWidth();
          this._disableOverFlow(), this._setElementAttributes(this._element, o, (h) => h + y), this._setElementAttributes(s, o, (h) => h + y), this._setElementAttributes(a, l, (h) => h - y);
        }
        reset() {
          this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, o), this._resetElementAttributes(s, o), this._resetElementAttributes(a, l);
        }
        isOverflowing() {
          return this.getWidth() > 0;
        }
        // Private
        _disableOverFlow() {
          this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
        }
        _setElementAttributes(y, h, g) {
          const N = this.getWidth(), w = (O) => {
            if (O !== this._element && window.innerWidth > O.clientWidth + N)
              return;
            this._saveInitialAttribute(O, h);
            const C = window.getComputedStyle(O).getPropertyValue(h);
            O.style.setProperty(h, `${g(Number.parseFloat(C))}px`);
          };
          this._applyManipulationCallback(y, w);
        }
        _saveInitialAttribute(y, h) {
          const g = y.style.getPropertyValue(h);
          g && n.setDataAttribute(y, h, g);
        }
        _resetElementAttributes(y, h) {
          const g = (N) => {
            const w = n.getDataAttribute(N, h);
            if (w === null) {
              N.style.removeProperty(h);
              return;
            }
            n.removeDataAttribute(N, h), N.style.setProperty(h, w);
          };
          this._applyManipulationCallback(y, g);
        }
        _applyManipulationCallback(y, h) {
          if (r.isElement(y)) {
            h(y);
            return;
          }
          for (const g of i.find(y, this._element))
            h(g);
        }
      }
      return p;
    });
  }(Ut)), Ut.exports;
}
/*!
  * Bootstrap modal.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function(t, e) {
  (function(n, i) {
    t.exports = i(St(), it(), ct(), Tn(), On(), Cn(), J(), Dn());
  })(q, function(n, i, r, s, a, o, l, p) {
    const d = "modal", h = ".bs.modal", g = ".data-api", N = "Escape", w = `hide${h}`, O = `hidePrevented${h}`, C = `hidden${h}`, P = `show${h}`, R = `shown${h}`, x = `resize${h}`, I = `click.dismiss${h}`, m = `mousedown.dismiss${h}`, _ = `keydown.dismiss${h}`, T = `click${h}${g}`, D = "modal-open", u = "fade", v = "show", b = "modal-static", A = ".modal.show", S = ".modal-dialog", L = ".modal-body", k = '[data-bs-toggle="modal"]', V = {
      backdrop: !0,
      focus: !0,
      keyboard: !0
    }, F = {
      backdrop: "(boolean|string)",
      focus: "boolean",
      keyboard: "boolean"
    };
    class $ extends n {
      constructor(f, c) {
        super(f, c), this._dialog = r.findOne(S, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new p(), this._addEventListeners();
      }
      // Getters
      static get Default() {
        return V;
      }
      static get DefaultType() {
        return F;
      }
      static get NAME() {
        return d;
      }
      // Public
      toggle(f) {
        return this._isShown ? this.hide() : this.show(f);
      }
      show(f) {
        this._isShown || this._isTransitioning || i.trigger(this._element, P, {
          relatedTarget: f
        }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(D), this._adjustDialog(), this._backdrop.show(() => this._showElement(f)));
      }
      hide() {
        !this._isShown || this._isTransitioning || i.trigger(this._element, w).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(v), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
      }
      dispose() {
        i.off(window, h), i.off(this._dialog, h), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
      }
      handleUpdate() {
        this._adjustDialog();
      }
      // Private
      _initializeBackDrop() {
        return new s({
          isVisible: !!this._config.backdrop,
          // 'static' option will be translated to true, and booleans will keep their value,
          isAnimated: this._isAnimated()
        });
      }
      _initializeFocusTrap() {
        return new o({
          trapElement: this._element
        });
      }
      _showElement(f) {
        document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
        const c = r.findOne(L, this._dialog);
        c && (c.scrollTop = 0), l.reflow(this._element), this._element.classList.add(v);
        const E = () => {
          this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, i.trigger(this._element, R, {
            relatedTarget: f
          });
        };
        this._queueCallback(E, this._dialog, this._isAnimated());
      }
      _addEventListeners() {
        i.on(this._element, _, (f) => {
          if (f.key === N) {
            if (this._config.keyboard) {
              this.hide();
              return;
            }
            this._triggerBackdropTransition();
          }
        }), i.on(window, x, () => {
          this._isShown && !this._isTransitioning && this._adjustDialog();
        }), i.on(this._element, m, (f) => {
          i.one(this._element, I, (c) => {
            if (!(this._element !== f.target || this._element !== c.target)) {
              if (this._config.backdrop === "static") {
                this._triggerBackdropTransition();
                return;
              }
              this._config.backdrop && this.hide();
            }
          });
        });
      }
      _hideModal() {
        this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(() => {
          document.body.classList.remove(D), this._resetAdjustments(), this._scrollBar.reset(), i.trigger(this._element, C);
        });
      }
      _isAnimated() {
        return this._element.classList.contains(u);
      }
      _triggerBackdropTransition() {
        if (i.trigger(this._element, O).defaultPrevented)
          return;
        const c = this._element.scrollHeight > document.documentElement.clientHeight, E = this._element.style.overflowY;
        E === "hidden" || this._element.classList.contains(b) || (c || (this._element.style.overflowY = "hidden"), this._element.classList.add(b), this._queueCallback(() => {
          this._element.classList.remove(b), this._queueCallback(() => {
            this._element.style.overflowY = E;
          }, this._dialog);
        }, this._dialog), this._element.focus());
      }
      /**
       * The following methods are used to handle overflowing modals
       */
      _adjustDialog() {
        const f = this._element.scrollHeight > document.documentElement.clientHeight, c = this._scrollBar.getWidth(), E = c > 0;
        if (E && !f) {
          const M = l.isRTL() ? "paddingLeft" : "paddingRight";
          this._element.style[M] = `${c}px`;
        }
        if (!E && f) {
          const M = l.isRTL() ? "paddingRight" : "paddingLeft";
          this._element.style[M] = `${c}px`;
        }
      }
      _resetAdjustments() {
        this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
      }
      // Static
      static jQueryInterface(f, c) {
        return this.each(function() {
          const E = $.getOrCreateInstance(this, f);
          if (typeof f == "string") {
            if (typeof E[f] > "u")
              throw new TypeError(`No method named "${f}"`);
            E[f](c);
          }
        });
      }
    }
    return i.on(document, T, k, function(B) {
      const f = r.getElementFromSelector(this);
      ["A", "AREA"].includes(this.tagName) && B.preventDefault(), i.one(f, P, (M) => {
        M.defaultPrevented || i.one(f, C, () => {
          l.isVisible(this) && this.focus();
        });
      });
      const c = r.findOne(A);
      c && $.getInstance(c).hide(), $.getOrCreateInstance(f).toggle(this);
    }), a.enableDismissTrigger($), l.defineJQueryPlugin($), $;
  });
})(We);
var Nn = We.exports;
const Ci = /* @__PURE__ */ Nt(Nn);
var Be = { exports: {} };
/*!
  * Bootstrap collapse.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function(t, e) {
  (function(n, i) {
    t.exports = i(St(), it(), ct(), J());
  })(q, function(n, i, r, s) {
    const a = "collapse", l = ".bs.collapse", p = ".data-api", d = `show${l}`, y = `shown${l}`, h = `hide${l}`, g = `hidden${l}`, N = `click${l}${p}`, w = "show", O = "collapse", C = "collapsing", P = "collapsed", R = `:scope .${O} .${O}`, x = "collapse-horizontal", I = "width", m = "height", _ = ".collapse.show, .collapse.collapsing", T = '[data-bs-toggle="collapse"]', D = {
      parent: null,
      toggle: !0
    }, u = {
      parent: "(null|element)",
      toggle: "boolean"
    };
    class v extends n {
      constructor(A, S) {
        super(A, S), this._isTransitioning = !1, this._triggerArray = [];
        const L = r.find(T);
        for (const k of L) {
          const V = r.getSelectorFromElement(k), F = r.find(V).filter(($) => $ === this._element);
          V !== null && F.length && this._triggerArray.push(k);
        }
        this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
      }
      // Getters
      static get Default() {
        return D;
      }
      static get DefaultType() {
        return u;
      }
      static get NAME() {
        return a;
      }
      // Public
      toggle() {
        this._isShown() ? this.hide() : this.show();
      }
      show() {
        if (this._isTransitioning || this._isShown())
          return;
        let A = [];
        if (this._config.parent && (A = this._getFirstLevelChildren(_).filter(($) => $ !== this._element).map(($) => v.getOrCreateInstance($, {
          toggle: !1
        }))), A.length && A[0]._isTransitioning || i.trigger(this._element, d).defaultPrevented)
          return;
        for (const $ of A)
          $.hide();
        const L = this._getDimension();
        this._element.classList.remove(O), this._element.classList.add(C), this._element.style[L] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
        const k = () => {
          this._isTransitioning = !1, this._element.classList.remove(C), this._element.classList.add(O, w), this._element.style[L] = "", i.trigger(this._element, y);
        }, F = `scroll${L[0].toUpperCase() + L.slice(1)}`;
        this._queueCallback(k, this._element, !0), this._element.style[L] = `${this._element[F]}px`;
      }
      hide() {
        if (this._isTransitioning || !this._isShown() || i.trigger(this._element, h).defaultPrevented)
          return;
        const S = this._getDimension();
        this._element.style[S] = `${this._element.getBoundingClientRect()[S]}px`, s.reflow(this._element), this._element.classList.add(C), this._element.classList.remove(O, w);
        for (const k of this._triggerArray) {
          const V = r.getElementFromSelector(k);
          V && !this._isShown(V) && this._addAriaAndCollapsedClass([k], !1);
        }
        this._isTransitioning = !0;
        const L = () => {
          this._isTransitioning = !1, this._element.classList.remove(C), this._element.classList.add(O), i.trigger(this._element, g);
        };
        this._element.style[S] = "", this._queueCallback(L, this._element, !0);
      }
      _isShown(A = this._element) {
        return A.classList.contains(w);
      }
      // Private
      _configAfterMerge(A) {
        return A.toggle = !!A.toggle, A.parent = s.getElement(A.parent), A;
      }
      _getDimension() {
        return this._element.classList.contains(x) ? I : m;
      }
      _initializeChildren() {
        if (!this._config.parent)
          return;
        const A = this._getFirstLevelChildren(T);
        for (const S of A) {
          const L = r.getElementFromSelector(S);
          L && this._addAriaAndCollapsedClass([S], this._isShown(L));
        }
      }
      _getFirstLevelChildren(A) {
        const S = r.find(R, this._config.parent);
        return r.find(A, this._config.parent).filter((L) => !S.includes(L));
      }
      _addAriaAndCollapsedClass(A, S) {
        if (A.length)
          for (const L of A)
            L.classList.toggle(P, !S), L.setAttribute("aria-expanded", S);
      }
      // Static
      static jQueryInterface(A) {
        const S = {};
        return typeof A == "string" && /show|hide/.test(A) && (S.toggle = !1), this.each(function() {
          const L = v.getOrCreateInstance(this, S);
          if (typeof A == "string") {
            if (typeof L[A] > "u")
              throw new TypeError(`No method named "${A}"`);
            L[A]();
          }
        });
      }
    }
    return i.on(document, N, T, function(b) {
      (b.target.tagName === "A" || b.delegateTarget && b.delegateTarget.tagName === "A") && b.preventDefault();
      for (const A of r.getMultipleElementsFromSelector(this))
        v.getOrCreateInstance(A, {
          toggle: !1
        }).toggle();
    }), s.defineJQueryPlugin(v), v;
  });
})(Be);
var xn = Be.exports;
const Di = /* @__PURE__ */ Nt(xn);
var je = { exports: {} };
/*!
  * Bootstrap tab.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function(t, e) {
  (function(n, i) {
    t.exports = i(St(), it(), ct(), J());
  })(q, function(n, i, r, s) {
    const a = "tab", l = ".bs.tab", p = `hide${l}`, d = `hidden${l}`, y = `show${l}`, h = `shown${l}`, g = `click${l}`, N = `keydown${l}`, w = `load${l}`, O = "ArrowLeft", C = "ArrowRight", P = "ArrowUp", R = "ArrowDown", x = "Home", I = "End", m = "active", _ = "fade", T = "show", D = "dropdown", u = ".dropdown-toggle", v = ".dropdown-menu", b = `:not(${u})`, A = '.list-group, .nav, [role="tablist"]', S = ".nav-item, .list-group-item", L = `.nav-link${b}, .list-group-item${b}, [role="tab"]${b}`, k = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', V = `${L}, ${k}`, F = `.${m}[data-bs-toggle="tab"], .${m}[data-bs-toggle="pill"], .${m}[data-bs-toggle="list"]`;
    class $ extends n {
      constructor(f) {
        super(f), this._parent = this._element.closest(A), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), i.on(this._element, N, (c) => this._keydown(c)));
      }
      // Getters
      static get NAME() {
        return a;
      }
      // Public
      show() {
        const f = this._element;
        if (this._elemIsActive(f))
          return;
        const c = this._getActiveElem(), E = c ? i.trigger(c, p, {
          relatedTarget: f
        }) : null;
        i.trigger(f, y, {
          relatedTarget: c
        }).defaultPrevented || E && E.defaultPrevented || (this._deactivate(c, f), this._activate(f, c));
      }
      // Private
      _activate(f, c) {
        if (!f)
          return;
        f.classList.add(m), this._activate(r.getElementFromSelector(f));
        const E = () => {
          if (f.getAttribute("role") !== "tab") {
            f.classList.add(T);
            return;
          }
          f.removeAttribute("tabindex"), f.setAttribute("aria-selected", !0), this._toggleDropDown(f, !0), i.trigger(f, h, {
            relatedTarget: c
          });
        };
        this._queueCallback(E, f, f.classList.contains(_));
      }
      _deactivate(f, c) {
        if (!f)
          return;
        f.classList.remove(m), f.blur(), this._deactivate(r.getElementFromSelector(f));
        const E = () => {
          if (f.getAttribute("role") !== "tab") {
            f.classList.remove(T);
            return;
          }
          f.setAttribute("aria-selected", !1), f.setAttribute("tabindex", "-1"), this._toggleDropDown(f, !1), i.trigger(f, d, {
            relatedTarget: c
          });
        };
        this._queueCallback(E, f, f.classList.contains(_));
      }
      _keydown(f) {
        if (![O, C, P, R, x, I].includes(f.key))
          return;
        f.stopPropagation(), f.preventDefault();
        const c = this._getChildren().filter((M) => !s.isDisabled(M));
        let E;
        if ([x, I].includes(f.key))
          E = c[f.key === x ? 0 : c.length - 1];
        else {
          const M = [C, R].includes(f.key);
          E = s.getNextActiveElement(c, f.target, M, !0);
        }
        E && (E.focus({
          preventScroll: !0
        }), $.getOrCreateInstance(E).show());
      }
      _getChildren() {
        return r.find(V, this._parent);
      }
      _getActiveElem() {
        return this._getChildren().find((f) => this._elemIsActive(f)) || null;
      }
      _setInitialAttributes(f, c) {
        this._setAttributeIfNotExists(f, "role", "tablist");
        for (const E of c)
          this._setInitialAttributesOnChild(E);
      }
      _setInitialAttributesOnChild(f) {
        f = this._getInnerElement(f);
        const c = this._elemIsActive(f), E = this._getOuterElement(f);
        f.setAttribute("aria-selected", c), E !== f && this._setAttributeIfNotExists(E, "role", "presentation"), c || f.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(f, "role", "tab"), this._setInitialAttributesOnTargetPanel(f);
      }
      _setInitialAttributesOnTargetPanel(f) {
        const c = r.getElementFromSelector(f);
        c && (this._setAttributeIfNotExists(c, "role", "tabpanel"), f.id && this._setAttributeIfNotExists(c, "aria-labelledby", `${f.id}`));
      }
      _toggleDropDown(f, c) {
        const E = this._getOuterElement(f);
        if (!E.classList.contains(D))
          return;
        const M = (W, H) => {
          const U = r.findOne(W, E);
          U && U.classList.toggle(H, c);
        };
        M(u, m), M(v, T), E.setAttribute("aria-expanded", c);
      }
      _setAttributeIfNotExists(f, c, E) {
        f.hasAttribute(c) || f.setAttribute(c, E);
      }
      _elemIsActive(f) {
        return f.classList.contains(m);
      }
      // Try to get the inner element (usually the .nav-link)
      _getInnerElement(f) {
        return f.matches(V) ? f : r.findOne(V, f);
      }
      // Try to get the outer element (usually the .nav-item)
      _getOuterElement(f) {
        return f.closest(S) || f;
      }
      // Static
      static jQueryInterface(f) {
        return this.each(function() {
          const c = $.getOrCreateInstance(this);
          if (typeof f == "string") {
            if (c[f] === void 0 || f.startsWith("_") || f === "constructor")
              throw new TypeError(`No method named "${f}"`);
            c[f]();
          }
        });
      }
    }
    return i.on(document, g, k, function(B) {
      ["A", "AREA"].includes(this.tagName) && B.preventDefault(), !s.isDisabled(this) && $.getOrCreateInstance(this).show();
    }), i.on(window, w, () => {
      for (const B of r.find(F))
        $.getOrCreateInstance(B);
    }), s.defineJQueryPlugin($), $;
  });
})(je);
var Sn = je.exports;
const Ni = /* @__PURE__ */ Nt(Sn);
let wt;
const Ln = new Uint8Array(16);
function Rn() {
  if (!wt && (wt = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !wt))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return wt(Ln);
}
const j = [];
for (let t = 0; t < 256; ++t)
  j.push((t + 256).toString(16).slice(1));
function Pn(t, e = 0) {
  return j[t[e + 0]] + j[t[e + 1]] + j[t[e + 2]] + j[t[e + 3]] + "-" + j[t[e + 4]] + j[t[e + 5]] + "-" + j[t[e + 6]] + j[t[e + 7]] + "-" + j[t[e + 8]] + j[t[e + 9]] + "-" + j[t[e + 10]] + j[t[e + 11]] + j[t[e + 12]] + j[t[e + 13]] + j[t[e + 14]] + j[t[e + 15]];
}
const In = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), xe = {
  randomUUID: In
};
function xi(t, e, n) {
  if (xe.randomUUID && !t)
    return xe.randomUUID();
  t = t || {};
  const i = t.random || (t.rng || Rn)();
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Pn(i);
}
var qe = { exports: {} }, Y = "top", K = "bottom", G = "right", z = "left", Lt = "auto", mt = [Y, K, G, z], at = "start", ft = "end", He = "clippingParents", Xt = "viewport", ut = "popper", Ue = "reference", zt = /* @__PURE__ */ mt.reduce(function(t, e) {
  return t.concat([e + "-" + at, e + "-" + ft]);
}, []), Jt = /* @__PURE__ */ [].concat(mt, [Lt]).reduce(function(t, e) {
  return t.concat([e, e + "-" + at, e + "-" + ft]);
}, []), Ye = "beforeRead", ze = "read", Ke = "afterRead", Ge = "beforeMain", Qe = "main", Xe = "afterMain", Je = "beforeWrite", Ze = "write", tn = "afterWrite", en = [Ye, ze, Ke, Ge, Qe, Xe, Je, Ze, tn];
function tt(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Q(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function lt(t) {
  var e = Q(t).Element;
  return t instanceof e || t instanceof Element;
}
function X(t) {
  var e = Q(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Zt(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Q(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Mn(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var i = e.styles[n] || {}, r = e.attributes[n] || {}, s = e.elements[n];
    !X(s) || !tt(s) || (Object.assign(s.style, i), Object.keys(r).forEach(function(a) {
      var o = r[a];
      o === !1 ? s.removeAttribute(a) : s.setAttribute(a, o === !0 ? "" : o);
    }));
  });
}
function kn(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(i) {
      var r = e.elements[i], s = e.attributes[i] || {}, a = Object.keys(e.styles.hasOwnProperty(i) ? e.styles[i] : n[i]), o = a.reduce(function(l, p) {
        return l[p] = "", l;
      }, {});
      !X(r) || !tt(r) || (Object.assign(r.style, o), Object.keys(s).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const te = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Mn,
  effect: kn,
  requires: ["computeStyles"]
};
function Z(t) {
  return t.split("-")[0];
}
var ot = Math.max, Dt = Math.min, pt = Math.round;
function Kt() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function nn() {
  return !/^((?!chrome|android).)*safari/i.test(Kt());
}
function dt(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var i = t.getBoundingClientRect(), r = 1, s = 1;
  e && X(t) && (r = t.offsetWidth > 0 && pt(i.width) / t.offsetWidth || 1, s = t.offsetHeight > 0 && pt(i.height) / t.offsetHeight || 1);
  var a = lt(t) ? Q(t) : window, o = a.visualViewport, l = !nn() && n, p = (i.left + (l && o ? o.offsetLeft : 0)) / r, d = (i.top + (l && o ? o.offsetTop : 0)) / s, y = i.width / r, h = i.height / s;
  return {
    width: y,
    height: h,
    top: d,
    right: p + y,
    bottom: d + h,
    left: p,
    x: p,
    y: d
  };
}
function ee(t) {
  var e = dt(t), n = t.offsetWidth, i = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - i) <= 1 && (i = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: i
  };
}
function rn(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && Zt(n)) {
    var i = e;
    do {
      if (i && t.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function nt(t) {
  return Q(t).getComputedStyle(t);
}
function $n(t) {
  return ["table", "td", "th"].indexOf(tt(t)) >= 0;
}
function rt(t) {
  return ((lt(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function Rt(t) {
  return tt(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Zt(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    rt(t)
  );
}
function Se(t) {
  return !X(t) || // https://github.com/popperjs/popper-core/issues/837
  nt(t).position === "fixed" ? null : t.offsetParent;
}
function Vn(t) {
  var e = /firefox/i.test(Kt()), n = /Trident/i.test(Kt());
  if (n && X(t)) {
    var i = nt(t);
    if (i.position === "fixed")
      return null;
  }
  var r = Rt(t);
  for (Zt(r) && (r = r.host); X(r) && ["html", "body"].indexOf(tt(r)) < 0; ) {
    var s = nt(r);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || e && s.willChange === "filter" || e && s.filter && s.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function bt(t) {
  for (var e = Q(t), n = Se(t); n && $n(n) && nt(n).position === "static"; )
    n = Se(n);
  return n && (tt(n) === "html" || tt(n) === "body" && nt(n).position === "static") ? e : n || Vn(t) || e;
}
function ne(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function _t(t, e, n) {
  return ot(t, Dt(e, n));
}
function Fn(t, e, n) {
  var i = _t(t, e, n);
  return i > n ? n : i;
}
function sn() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function on(t) {
  return Object.assign({}, sn(), t);
}
function an(t, e) {
  return e.reduce(function(n, i) {
    return n[i] = t, n;
  }, {});
}
var Wn = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, on(typeof e != "number" ? e : an(e, mt));
};
function Bn(t) {
  var e, n = t.state, i = t.name, r = t.options, s = n.elements.arrow, a = n.modifiersData.popperOffsets, o = Z(n.placement), l = ne(o), p = [z, G].indexOf(o) >= 0, d = p ? "height" : "width";
  if (!(!s || !a)) {
    var y = Wn(r.padding, n), h = ee(s), g = l === "y" ? Y : z, N = l === "y" ? K : G, w = n.rects.reference[d] + n.rects.reference[l] - a[l] - n.rects.popper[d], O = a[l] - n.rects.reference[l], C = bt(s), P = C ? l === "y" ? C.clientHeight || 0 : C.clientWidth || 0 : 0, R = w / 2 - O / 2, x = y[g], I = P - h[d] - y[N], m = P / 2 - h[d] / 2 + R, _ = _t(x, m, I), T = l;
    n.modifiersData[i] = (e = {}, e[T] = _, e.centerOffset = _ - m, e);
  }
}
function jn(t) {
  var e = t.state, n = t.options, i = n.element, r = i === void 0 ? "[data-popper-arrow]" : i;
  r != null && (typeof r == "string" && (r = e.elements.popper.querySelector(r), !r) || rn(e.elements.popper, r) && (e.elements.arrow = r));
}
const ln = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Bn,
  effect: jn,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ht(t) {
  return t.split("-")[1];
}
var qn = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Hn(t, e) {
  var n = t.x, i = t.y, r = e.devicePixelRatio || 1;
  return {
    x: pt(n * r) / r || 0,
    y: pt(i * r) / r || 0
  };
}
function Le(t) {
  var e, n = t.popper, i = t.popperRect, r = t.placement, s = t.variation, a = t.offsets, o = t.position, l = t.gpuAcceleration, p = t.adaptive, d = t.roundOffsets, y = t.isFixed, h = a.x, g = h === void 0 ? 0 : h, N = a.y, w = N === void 0 ? 0 : N, O = typeof d == "function" ? d({
    x: g,
    y: w
  }) : {
    x: g,
    y: w
  };
  g = O.x, w = O.y;
  var C = a.hasOwnProperty("x"), P = a.hasOwnProperty("y"), R = z, x = Y, I = window;
  if (p) {
    var m = bt(n), _ = "clientHeight", T = "clientWidth";
    if (m === Q(n) && (m = rt(n), nt(m).position !== "static" && o === "absolute" && (_ = "scrollHeight", T = "scrollWidth")), m = m, r === Y || (r === z || r === G) && s === ft) {
      x = K;
      var D = y && m === I && I.visualViewport ? I.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        m[_]
      );
      w -= D - i.height, w *= l ? 1 : -1;
    }
    if (r === z || (r === Y || r === K) && s === ft) {
      R = G;
      var u = y && m === I && I.visualViewport ? I.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        m[T]
      );
      g -= u - i.width, g *= l ? 1 : -1;
    }
  }
  var v = Object.assign({
    position: o
  }, p && qn), b = d === !0 ? Hn({
    x: g,
    y: w
  }, Q(n)) : {
    x: g,
    y: w
  };
  if (g = b.x, w = b.y, l) {
    var A;
    return Object.assign({}, v, (A = {}, A[x] = P ? "0" : "", A[R] = C ? "0" : "", A.transform = (I.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + w + "px)" : "translate3d(" + g + "px, " + w + "px, 0)", A));
  }
  return Object.assign({}, v, (e = {}, e[x] = P ? w + "px" : "", e[R] = C ? g + "px" : "", e.transform = "", e));
}
function Un(t) {
  var e = t.state, n = t.options, i = n.gpuAcceleration, r = i === void 0 ? !0 : i, s = n.adaptive, a = s === void 0 ? !0 : s, o = n.roundOffsets, l = o === void 0 ? !0 : o, p = {
    placement: Z(e.placement),
    variation: ht(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: r,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Le(Object.assign({}, p, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Le(Object.assign({}, p, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const ie = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Un,
  data: {}
};
var Tt = {
  passive: !0
};
function Yn(t) {
  var e = t.state, n = t.instance, i = t.options, r = i.scroll, s = r === void 0 ? !0 : r, a = i.resize, o = a === void 0 ? !0 : a, l = Q(e.elements.popper), p = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return s && p.forEach(function(d) {
    d.addEventListener("scroll", n.update, Tt);
  }), o && l.addEventListener("resize", n.update, Tt), function() {
    s && p.forEach(function(d) {
      d.removeEventListener("scroll", n.update, Tt);
    }), o && l.removeEventListener("resize", n.update, Tt);
  };
}
const re = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Yn,
  data: {}
};
var zn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ct(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return zn[e];
  });
}
var Kn = {
  start: "end",
  end: "start"
};
function Re(t) {
  return t.replace(/start|end/g, function(e) {
    return Kn[e];
  });
}
function se(t) {
  var e = Q(t), n = e.pageXOffset, i = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: i
  };
}
function oe(t) {
  return dt(rt(t)).left + se(t).scrollLeft;
}
function Gn(t, e) {
  var n = Q(t), i = rt(t), r = n.visualViewport, s = i.clientWidth, a = i.clientHeight, o = 0, l = 0;
  if (r) {
    s = r.width, a = r.height;
    var p = nn();
    (p || !p && e === "fixed") && (o = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: o + oe(t),
    y: l
  };
}
function Qn(t) {
  var e, n = rt(t), i = se(t), r = (e = t.ownerDocument) == null ? void 0 : e.body, s = ot(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), a = ot(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), o = -i.scrollLeft + oe(t), l = -i.scrollTop;
  return nt(r || n).direction === "rtl" && (o += ot(n.clientWidth, r ? r.clientWidth : 0) - s), {
    width: s,
    height: a,
    x: o,
    y: l
  };
}
function ae(t) {
  var e = nt(t), n = e.overflow, i = e.overflowX, r = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + i);
}
function cn(t) {
  return ["html", "body", "#document"].indexOf(tt(t)) >= 0 ? t.ownerDocument.body : X(t) && ae(t) ? t : cn(Rt(t));
}
function vt(t, e) {
  var n;
  e === void 0 && (e = []);
  var i = cn(t), r = i === ((n = t.ownerDocument) == null ? void 0 : n.body), s = Q(i), a = r ? [s].concat(s.visualViewport || [], ae(i) ? i : []) : i, o = e.concat(a);
  return r ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat(vt(Rt(a)))
  );
}
function Gt(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Xn(t, e) {
  var n = dt(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Pe(t, e, n) {
  return e === Xt ? Gt(Gn(t, n)) : lt(e) ? Xn(e, n) : Gt(Qn(rt(t)));
}
function Jn(t) {
  var e = vt(Rt(t)), n = ["absolute", "fixed"].indexOf(nt(t).position) >= 0, i = n && X(t) ? bt(t) : t;
  return lt(i) ? e.filter(function(r) {
    return lt(r) && rn(r, i) && tt(r) !== "body";
  }) : [];
}
function Zn(t, e, n, i) {
  var r = e === "clippingParents" ? Jn(t) : [].concat(e), s = [].concat(r, [n]), a = s[0], o = s.reduce(function(l, p) {
    var d = Pe(t, p, i);
    return l.top = ot(d.top, l.top), l.right = Dt(d.right, l.right), l.bottom = Dt(d.bottom, l.bottom), l.left = ot(d.left, l.left), l;
  }, Pe(t, a, i));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function un(t) {
  var e = t.reference, n = t.element, i = t.placement, r = i ? Z(i) : null, s = i ? ht(i) : null, a = e.x + e.width / 2 - n.width / 2, o = e.y + e.height / 2 - n.height / 2, l;
  switch (r) {
    case Y:
      l = {
        x: a,
        y: e.y - n.height
      };
      break;
    case K:
      l = {
        x: a,
        y: e.y + e.height
      };
      break;
    case G:
      l = {
        x: e.x + e.width,
        y: o
      };
      break;
    case z:
      l = {
        x: e.x - n.width,
        y: o
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var p = r ? ne(r) : null;
  if (p != null) {
    var d = p === "y" ? "height" : "width";
    switch (s) {
      case at:
        l[p] = l[p] - (e[d] / 2 - n[d] / 2);
        break;
      case ft:
        l[p] = l[p] + (e[d] / 2 - n[d] / 2);
        break;
    }
  }
  return l;
}
function gt(t, e) {
  e === void 0 && (e = {});
  var n = e, i = n.placement, r = i === void 0 ? t.placement : i, s = n.strategy, a = s === void 0 ? t.strategy : s, o = n.boundary, l = o === void 0 ? He : o, p = n.rootBoundary, d = p === void 0 ? Xt : p, y = n.elementContext, h = y === void 0 ? ut : y, g = n.altBoundary, N = g === void 0 ? !1 : g, w = n.padding, O = w === void 0 ? 0 : w, C = on(typeof O != "number" ? O : an(O, mt)), P = h === ut ? Ue : ut, R = t.rects.popper, x = t.elements[N ? P : h], I = Zn(lt(x) ? x : x.contextElement || rt(t.elements.popper), l, d, a), m = dt(t.elements.reference), _ = un({
    reference: m,
    element: R,
    placement: r
  }), T = Gt(Object.assign({}, R, _)), D = h === ut ? T : m, u = {
    top: I.top - D.top + C.top,
    bottom: D.bottom - I.bottom + C.bottom,
    left: I.left - D.left + C.left,
    right: D.right - I.right + C.right
  }, v = t.modifiersData.offset;
  if (h === ut && v) {
    var b = v[r];
    Object.keys(u).forEach(function(A) {
      var S = [G, K].indexOf(A) >= 0 ? 1 : -1, L = [Y, K].indexOf(A) >= 0 ? "y" : "x";
      u[A] += b[L] * S;
    });
  }
  return u;
}
function ti(t, e) {
  e === void 0 && (e = {});
  var n = e, i = n.placement, r = n.boundary, s = n.rootBoundary, a = n.padding, o = n.flipVariations, l = n.allowedAutoPlacements, p = l === void 0 ? Jt : l, d = ht(i), y = d ? o ? zt : zt.filter(function(N) {
    return ht(N) === d;
  }) : mt, h = y.filter(function(N) {
    return p.indexOf(N) >= 0;
  });
  h.length === 0 && (h = y);
  var g = h.reduce(function(N, w) {
    return N[w] = gt(t, {
      placement: w,
      boundary: r,
      rootBoundary: s,
      padding: a
    })[Z(w)], N;
  }, {});
  return Object.keys(g).sort(function(N, w) {
    return g[N] - g[w];
  });
}
function ei(t) {
  if (Z(t) === Lt)
    return [];
  var e = Ct(t);
  return [Re(t), e, Re(e)];
}
function ni(t) {
  var e = t.state, n = t.options, i = t.name;
  if (!e.modifiersData[i]._skip) {
    for (var r = n.mainAxis, s = r === void 0 ? !0 : r, a = n.altAxis, o = a === void 0 ? !0 : a, l = n.fallbackPlacements, p = n.padding, d = n.boundary, y = n.rootBoundary, h = n.altBoundary, g = n.flipVariations, N = g === void 0 ? !0 : g, w = n.allowedAutoPlacements, O = e.options.placement, C = Z(O), P = C === O, R = l || (P || !N ? [Ct(O)] : ei(O)), x = [O].concat(R).reduce(function(M, W) {
      return M.concat(Z(W) === Lt ? ti(e, {
        placement: W,
        boundary: d,
        rootBoundary: y,
        padding: p,
        flipVariations: N,
        allowedAutoPlacements: w
      }) : W);
    }, []), I = e.rects.reference, m = e.rects.popper, _ = /* @__PURE__ */ new Map(), T = !0, D = x[0], u = 0; u < x.length; u++) {
      var v = x[u], b = Z(v), A = ht(v) === at, S = [Y, K].indexOf(b) >= 0, L = S ? "width" : "height", k = gt(e, {
        placement: v,
        boundary: d,
        rootBoundary: y,
        altBoundary: h,
        padding: p
      }), V = S ? A ? G : z : A ? K : Y;
      I[L] > m[L] && (V = Ct(V));
      var F = Ct(V), $ = [];
      if (s && $.push(k[b] <= 0), o && $.push(k[V] <= 0, k[F] <= 0), $.every(function(M) {
        return M;
      })) {
        D = v, T = !1;
        break;
      }
      _.set(v, $);
    }
    if (T)
      for (var B = N ? 3 : 1, f = function(W) {
        var H = x.find(function(U) {
          var et = _.get(U);
          if (et)
            return et.slice(0, W).every(function(It) {
              return It;
            });
        });
        if (H)
          return D = H, "break";
      }, c = B; c > 0; c--) {
        var E = f(c);
        if (E === "break") break;
      }
    e.placement !== D && (e.modifiersData[i]._skip = !0, e.placement = D, e.reset = !0);
  }
}
const fn = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: ni,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ie(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function Me(t) {
  return [Y, G, K, z].some(function(e) {
    return t[e] >= 0;
  });
}
function ii(t) {
  var e = t.state, n = t.name, i = e.rects.reference, r = e.rects.popper, s = e.modifiersData.preventOverflow, a = gt(e, {
    elementContext: "reference"
  }), o = gt(e, {
    altBoundary: !0
  }), l = Ie(a, i), p = Ie(o, r, s), d = Me(l), y = Me(p);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: p,
    isReferenceHidden: d,
    hasPopperEscaped: y
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": y
  });
}
const pn = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: ii
};
function ri(t, e, n) {
  var i = Z(t), r = [z, Y].indexOf(i) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, a = s[0], o = s[1];
  return a = a || 0, o = (o || 0) * r, [z, G].indexOf(i) >= 0 ? {
    x: o,
    y: a
  } : {
    x: a,
    y: o
  };
}
function si(t) {
  var e = t.state, n = t.options, i = t.name, r = n.offset, s = r === void 0 ? [0, 0] : r, a = Jt.reduce(function(d, y) {
    return d[y] = ri(y, e.rects, s), d;
  }, {}), o = a[e.placement], l = o.x, p = o.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += p), e.modifiersData[i] = a;
}
const dn = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: si
};
function oi(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = un({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const le = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: oi,
  data: {}
};
function ai(t) {
  return t === "x" ? "y" : "x";
}
function li(t) {
  var e = t.state, n = t.options, i = t.name, r = n.mainAxis, s = r === void 0 ? !0 : r, a = n.altAxis, o = a === void 0 ? !1 : a, l = n.boundary, p = n.rootBoundary, d = n.altBoundary, y = n.padding, h = n.tether, g = h === void 0 ? !0 : h, N = n.tetherOffset, w = N === void 0 ? 0 : N, O = gt(e, {
    boundary: l,
    rootBoundary: p,
    padding: y,
    altBoundary: d
  }), C = Z(e.placement), P = ht(e.placement), R = !P, x = ne(C), I = ai(x), m = e.modifiersData.popperOffsets, _ = e.rects.reference, T = e.rects.popper, D = typeof w == "function" ? w(Object.assign({}, e.rects, {
    placement: e.placement
  })) : w, u = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), v = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, b = {
    x: 0,
    y: 0
  };
  if (m) {
    if (s) {
      var A, S = x === "y" ? Y : z, L = x === "y" ? K : G, k = x === "y" ? "height" : "width", V = m[x], F = V + O[S], $ = V - O[L], B = g ? -T[k] / 2 : 0, f = P === at ? _[k] : T[k], c = P === at ? -T[k] : -_[k], E = e.elements.arrow, M = g && E ? ee(E) : {
        width: 0,
        height: 0
      }, W = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : sn(), H = W[S], U = W[L], et = _t(0, _[k], M[k]), It = R ? _[k] / 2 - B - et - H - u.mainAxis : f - et - H - u.mainAxis, mn = R ? -_[k] / 2 + B + et + U + u.mainAxis : c + et + U + u.mainAxis, Mt = e.elements.arrow && bt(e.elements.arrow), _n = Mt ? x === "y" ? Mt.clientTop || 0 : Mt.clientLeft || 0 : 0, ce = (A = v == null ? void 0 : v[x]) != null ? A : 0, vn = V + It - ce - _n, bn = V + mn - ce, ue = _t(g ? Dt(F, vn) : F, V, g ? ot($, bn) : $);
      m[x] = ue, b[x] = ue - V;
    }
    if (o) {
      var fe, En = x === "x" ? Y : z, yn = x === "x" ? K : G, st = m[I], Et = I === "y" ? "height" : "width", pe = st + O[En], de = st - O[yn], kt = [Y, z].indexOf(C) !== -1, he = (fe = v == null ? void 0 : v[I]) != null ? fe : 0, ge = kt ? pe : st - _[Et] - T[Et] - he + u.altAxis, me = kt ? st + _[Et] + T[Et] - he - u.altAxis : de, _e = g && kt ? Fn(ge, st, me) : _t(g ? ge : pe, st, g ? me : de);
      m[I] = _e, b[I] = _e - st;
    }
    e.modifiersData[i] = b;
  }
}
const hn = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: li,
  requiresIfExists: ["offset"]
};
function ci(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function ui(t) {
  return t === Q(t) || !X(t) ? se(t) : ci(t);
}
function fi(t) {
  var e = t.getBoundingClientRect(), n = pt(e.width) / t.offsetWidth || 1, i = pt(e.height) / t.offsetHeight || 1;
  return n !== 1 || i !== 1;
}
function pi(t, e, n) {
  n === void 0 && (n = !1);
  var i = X(e), r = X(e) && fi(e), s = rt(e), a = dt(t, r, n), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (i || !i && !n) && ((tt(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ae(s)) && (o = ui(e)), X(e) ? (l = dt(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : s && (l.x = oe(s))), {
    x: a.left + o.scrollLeft - l.x,
    y: a.top + o.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function di(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), i = [];
  t.forEach(function(s) {
    e.set(s.name, s);
  });
  function r(s) {
    n.add(s.name);
    var a = [].concat(s.requires || [], s.requiresIfExists || []);
    a.forEach(function(o) {
      if (!n.has(o)) {
        var l = e.get(o);
        l && r(l);
      }
    }), i.push(s);
  }
  return t.forEach(function(s) {
    n.has(s.name) || r(s);
  }), i;
}
function hi(t) {
  var e = di(t);
  return en.reduce(function(n, i) {
    return n.concat(e.filter(function(r) {
      return r.phase === i;
    }));
  }, []);
}
function gi(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function mi(t) {
  var e = t.reduce(function(n, i) {
    var r = n[i.name];
    return n[i.name] = r ? Object.assign({}, r, i, {
      options: Object.assign({}, r.options, i.options),
      data: Object.assign({}, r.data, i.data)
    }) : i, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var ke = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function $e() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function Pt(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, i = n === void 0 ? [] : n, r = e.defaultOptions, s = r === void 0 ? ke : r;
  return function(o, l, p) {
    p === void 0 && (p = s);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ke, s),
      modifiersData: {},
      elements: {
        reference: o,
        popper: l
      },
      attributes: {},
      styles: {}
    }, y = [], h = !1, g = {
      state: d,
      setOptions: function(C) {
        var P = typeof C == "function" ? C(d.options) : C;
        w(), d.options = Object.assign({}, s, d.options, P), d.scrollParents = {
          reference: lt(o) ? vt(o) : o.contextElement ? vt(o.contextElement) : [],
          popper: vt(l)
        };
        var R = hi(mi([].concat(i, d.options.modifiers)));
        return d.orderedModifiers = R.filter(function(x) {
          return x.enabled;
        }), N(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var C = d.elements, P = C.reference, R = C.popper;
          if ($e(P, R)) {
            d.rects = {
              reference: pi(P, bt(R), d.options.strategy === "fixed"),
              popper: ee(R)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(u) {
              return d.modifiersData[u.name] = Object.assign({}, u.data);
            });
            for (var x = 0; x < d.orderedModifiers.length; x++) {
              if (d.reset === !0) {
                d.reset = !1, x = -1;
                continue;
              }
              var I = d.orderedModifiers[x], m = I.fn, _ = I.options, T = _ === void 0 ? {} : _, D = I.name;
              typeof m == "function" && (d = m({
                state: d,
                options: T,
                name: D,
                instance: g
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: gi(function() {
        return new Promise(function(O) {
          g.forceUpdate(), O(d);
        });
      }),
      destroy: function() {
        w(), h = !0;
      }
    };
    if (!$e(o, l))
      return g;
    g.setOptions(p).then(function(O) {
      !h && p.onFirstUpdate && p.onFirstUpdate(O);
    });
    function N() {
      d.orderedModifiers.forEach(function(O) {
        var C = O.name, P = O.options, R = P === void 0 ? {} : P, x = O.effect;
        if (typeof x == "function") {
          var I = x({
            state: d,
            name: C,
            instance: g,
            options: R
          }), m = function() {
          };
          y.push(I || m);
        }
      });
    }
    function w() {
      y.forEach(function(O) {
        return O();
      }), y = [];
    }
    return g;
  };
}
var _i = /* @__PURE__ */ Pt(), vi = [re, le, ie, te], bi = /* @__PURE__ */ Pt({
  defaultModifiers: vi
}), Ei = [re, le, ie, te, dn, fn, hn, ln, pn], yi = /* @__PURE__ */ Pt({
  defaultModifiers: Ei
});
const Ai = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  afterMain: Xe,
  afterRead: Ke,
  afterWrite: tn,
  applyStyles: te,
  arrow: ln,
  auto: Lt,
  basePlacements: mt,
  beforeMain: Ge,
  beforeRead: Ye,
  beforeWrite: Je,
  bottom: K,
  clippingParents: He,
  computeStyles: ie,
  createPopper: yi,
  createPopperBase: _i,
  createPopperLite: bi,
  detectOverflow: gt,
  end: ft,
  eventListeners: re,
  flip: fn,
  hide: pn,
  left: z,
  main: Qe,
  modifierPhases: en,
  offset: dn,
  placements: Jt,
  popper: ut,
  popperGenerator: Pt,
  popperOffsets: le,
  preventOverflow: hn,
  read: ze,
  reference: Ue,
  right: G,
  start: at,
  top: Y,
  variationPlacements: zt,
  viewport: Xt,
  write: Ze
}, Symbol.toStringTag, { value: "Module" })), wi = /* @__PURE__ */ An(Ai);
var Ot = { exports: {} };
/*!
  * Bootstrap sanitizer.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Ve;
function gn() {
  return Ve || (Ve = 1, function(t, e) {
    (function(n, i) {
      i(e);
    })(q, function(n) {
      const r = {
        // Global attributes allowed on any supplied element below.
        "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
        a: ["target", "href", "title", "rel"],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: ["src", "srcset", "alt", "title", "width", "height"],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
      }, s = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), a = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, o = (p, d) => {
        const y = p.nodeName.toLowerCase();
        return d.includes(y) ? s.has(y) ? !!a.test(p.nodeValue) : !0 : d.filter((h) => h instanceof RegExp).some((h) => h.test(y));
      };
      function l(p, d, y) {
        if (!p.length)
          return p;
        if (y && typeof y == "function")
          return y(p);
        const g = new window.DOMParser().parseFromString(p, "text/html"), N = [].concat(...g.body.querySelectorAll("*"));
        for (const w of N) {
          const O = w.nodeName.toLowerCase();
          if (!Object.keys(d).includes(O)) {
            w.remove();
            continue;
          }
          const C = [].concat(...w.attributes), P = [].concat(d["*"] || [], d[O] || []);
          for (const R of C)
            o(R, P) || w.removeAttribute(R.nodeName);
        }
        return g.body.innerHTML;
      }
      n.DefaultAllowlist = r, n.sanitizeHtml = l, Object.defineProperty(n, Symbol.toStringTag, { value: "Module" });
    });
  }(Ot, Ot.exports)), Ot.exports;
}
var Yt = { exports: {} };
/*!
  * Bootstrap template-factory.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
var Fe;
function Ti() {
  return Fe || (Fe = 1, function(t, e) {
    (function(n, i) {
      t.exports = i(ct(), xt(), gn(), J());
    })(q, function(n, i, r, s) {
      const a = "TemplateFactory", o = {
        allowList: r.DefaultAllowlist,
        content: {},
        // { selector : text ,  selector2 : text2 , }
        extraClass: "",
        html: !1,
        sanitize: !0,
        sanitizeFn: null,
        template: "<div></div>"
      }, l = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
      }, p = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
      };
      class d extends i {
        constructor(h) {
          super(), this._config = this._getConfig(h);
        }
        // Getters
        static get Default() {
          return o;
        }
        static get DefaultType() {
          return l;
        }
        static get NAME() {
          return a;
        }
        // Public
        getContent() {
          return Object.values(this._config.content).map((h) => this._resolvePossibleFunction(h)).filter(Boolean);
        }
        hasContent() {
          return this.getContent().length > 0;
        }
        changeContent(h) {
          return this._checkContent(h), this._config.content = {
            ...this._config.content,
            ...h
          }, this;
        }
        toHtml() {
          const h = document.createElement("div");
          h.innerHTML = this._maybeSanitize(this._config.template);
          for (const [w, O] of Object.entries(this._config.content))
            this._setContent(h, O, w);
          const g = h.children[0], N = this._resolvePossibleFunction(this._config.extraClass);
          return N && g.classList.add(...N.split(" ")), g;
        }
        // Private
        _typeCheckConfig(h) {
          super._typeCheckConfig(h), this._checkContent(h.content);
        }
        _checkContent(h) {
          for (const [g, N] of Object.entries(h))
            super._typeCheckConfig({
              selector: g,
              entry: N
            }, p);
        }
        _setContent(h, g, N) {
          const w = n.findOne(N, h);
          if (w) {
            if (g = this._resolvePossibleFunction(g), !g) {
              w.remove();
              return;
            }
            if (s.isElement(g)) {
              this._putElementInTemplate(s.getElement(g), w);
              return;
            }
            if (this._config.html) {
              w.innerHTML = this._maybeSanitize(g);
              return;
            }
            w.textContent = g;
          }
        }
        _maybeSanitize(h) {
          return this._config.sanitize ? r.sanitizeHtml(h, this._config.allowList, this._config.sanitizeFn) : h;
        }
        _resolvePossibleFunction(h) {
          return s.execute(h, [this]);
        }
        _putElementInTemplate(h, g) {
          if (this._config.html) {
            g.innerHTML = "", g.append(h);
            return;
          }
          g.textContent = h.textContent;
        }
      }
      return d;
    });
  }(Yt)), Yt.exports;
}
/*!
  * Bootstrap tooltip.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function(t, e) {
  (function(n, i) {
    t.exports = i(wi, St(), it(), Qt(), J(), gn(), Ti());
  })(q, function(n, i, r, s, a, o, l) {
    function p(f) {
      const c = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
      if (f) {
        for (const E in f)
          if (E !== "default") {
            const M = Object.getOwnPropertyDescriptor(f, E);
            Object.defineProperty(c, E, M.get ? M : {
              enumerable: !0,
              get: () => f[E]
            });
          }
      }
      return c.default = f, Object.freeze(c);
    }
    const d = /* @__PURE__ */ p(n), y = "tooltip", h = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), g = "fade", N = "modal", w = "show", O = ".tooltip-inner", C = `.${N}`, P = "hide.bs.modal", R = "hover", x = "focus", I = "click", m = "manual", _ = "hide", T = "hidden", D = "show", u = "shown", v = "inserted", b = "click", A = "focusin", S = "focusout", L = "mouseenter", k = "mouseleave", V = {
      AUTO: "auto",
      TOP: "top",
      RIGHT: a.isRTL() ? "left" : "right",
      BOTTOM: "bottom",
      LEFT: a.isRTL() ? "right" : "left"
    }, F = {
      allowList: o.DefaultAllowlist,
      animation: !0,
      boundary: "clippingParents",
      container: !1,
      customClass: "",
      delay: 0,
      fallbackPlacements: ["top", "right", "bottom", "left"],
      html: !1,
      offset: [0, 6],
      placement: "top",
      popperConfig: null,
      sanitize: !0,
      sanitizeFn: null,
      selector: !1,
      template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      title: "",
      trigger: "hover focus"
    }, $ = {
      allowList: "object",
      animation: "boolean",
      boundary: "(string|element)",
      container: "(string|element|boolean)",
      customClass: "(string|function)",
      delay: "(number|object)",
      fallbackPlacements: "array",
      html: "boolean",
      offset: "(array|string|function)",
      placement: "(string|function)",
      popperConfig: "(null|object|function)",
      sanitize: "boolean",
      sanitizeFn: "(null|function)",
      selector: "(string|boolean)",
      template: "string",
      title: "(string|element|function)",
      trigger: "string"
    };
    class B extends i {
      constructor(c, E) {
        if (typeof d > "u")
          throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(c, E), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
      }
      // Getters
      static get Default() {
        return F;
      }
      static get DefaultType() {
        return $;
      }
      static get NAME() {
        return y;
      }
      // Public
      enable() {
        this._isEnabled = !0;
      }
      disable() {
        this._isEnabled = !1;
      }
      toggleEnabled() {
        this._isEnabled = !this._isEnabled;
      }
      toggle() {
        if (this._isEnabled) {
          if (this._activeTrigger.click = !this._activeTrigger.click, this._isShown()) {
            this._leave();
            return;
          }
          this._enter();
        }
      }
      dispose() {
        clearTimeout(this._timeout), r.off(this._element.closest(C), P, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
      }
      show() {
        if (this._element.style.display === "none")
          throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled))
          return;
        const c = r.trigger(this._element, this.constructor.eventName(D)), M = (a.findShadowRoot(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
        if (c.defaultPrevented || !M)
          return;
        this._disposePopper();
        const W = this._getTipElement();
        this._element.setAttribute("aria-describedby", W.getAttribute("id"));
        const {
          container: H
        } = this._config;
        if (this._element.ownerDocument.documentElement.contains(this.tip) || (H.append(W), r.trigger(this._element, this.constructor.eventName(v))), this._popper = this._createPopper(W), W.classList.add(w), "ontouchstart" in document.documentElement)
          for (const et of [].concat(...document.body.children))
            r.on(et, "mouseover", a.noop);
        const U = () => {
          r.trigger(this._element, this.constructor.eventName(u)), this._isHovered === !1 && this._leave(), this._isHovered = !1;
        };
        this._queueCallback(U, this.tip, this._isAnimated());
      }
      hide() {
        if (!this._isShown() || r.trigger(this._element, this.constructor.eventName(_)).defaultPrevented)
          return;
        if (this._getTipElement().classList.remove(w), "ontouchstart" in document.documentElement)
          for (const W of [].concat(...document.body.children))
            r.off(W, "mouseover", a.noop);
        this._activeTrigger[I] = !1, this._activeTrigger[x] = !1, this._activeTrigger[R] = !1, this._isHovered = null;
        const M = () => {
          this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), r.trigger(this._element, this.constructor.eventName(T)));
        };
        this._queueCallback(M, this.tip, this._isAnimated());
      }
      update() {
        this._popper && this._popper.update();
      }
      // Protected
      _isWithContent() {
        return !!this._getTitle();
      }
      _getTipElement() {
        return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
      }
      _createTipElement(c) {
        const E = this._getTemplateFactory(c).toHtml();
        if (!E)
          return null;
        E.classList.remove(g, w), E.classList.add(`bs-${this.constructor.NAME}-auto`);
        const M = a.getUID(this.constructor.NAME).toString();
        return E.setAttribute("id", M), this._isAnimated() && E.classList.add(g), E;
      }
      setContent(c) {
        this._newContent = c, this._isShown() && (this._disposePopper(), this.show());
      }
      _getTemplateFactory(c) {
        return this._templateFactory ? this._templateFactory.changeContent(c) : this._templateFactory = new l({
          ...this._config,
          // the `content` var has to be after `this._config`
          // to override config.content in case of popover
          content: c,
          extraClass: this._resolvePossibleFunction(this._config.customClass)
        }), this._templateFactory;
      }
      _getContentForTemplate() {
        return {
          [O]: this._getTitle()
        };
      }
      _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
      }
      // Private
      _initializeOnDelegatedTarget(c) {
        return this.constructor.getOrCreateInstance(c.delegateTarget, this._getDelegateConfig());
      }
      _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains(g);
      }
      _isShown() {
        return this.tip && this.tip.classList.contains(w);
      }
      _createPopper(c) {
        const E = a.execute(this._config.placement, [this, c, this._element]), M = V[E.toUpperCase()];
        return d.createPopper(this._element, c, this._getPopperConfig(M));
      }
      _getOffset() {
        const {
          offset: c
        } = this._config;
        return typeof c == "string" ? c.split(",").map((E) => Number.parseInt(E, 10)) : typeof c == "function" ? (E) => c(E, this._element) : c;
      }
      _resolvePossibleFunction(c) {
        return a.execute(c, [this._element]);
      }
      _getPopperConfig(c) {
        const E = {
          placement: c,
          modifiers: [{
            name: "flip",
            options: {
              fallbackPlacements: this._config.fallbackPlacements
            }
          }, {
            name: "offset",
            options: {
              offset: this._getOffset()
            }
          }, {
            name: "preventOverflow",
            options: {
              boundary: this._config.boundary
            }
          }, {
            name: "arrow",
            options: {
              element: `.${this.constructor.NAME}-arrow`
            }
          }, {
            name: "preSetPlacement",
            enabled: !0,
            phase: "beforeMain",
            fn: (M) => {
              this._getTipElement().setAttribute("data-popper-placement", M.state.placement);
            }
          }]
        };
        return {
          ...E,
          ...a.execute(this._config.popperConfig, [E])
        };
      }
      _setListeners() {
        const c = this._config.trigger.split(" ");
        for (const E of c)
          if (E === "click")
            r.on(this._element, this.constructor.eventName(b), this._config.selector, (M) => {
              this._initializeOnDelegatedTarget(M).toggle();
            });
          else if (E !== m) {
            const M = E === R ? this.constructor.eventName(L) : this.constructor.eventName(A), W = E === R ? this.constructor.eventName(k) : this.constructor.eventName(S);
            r.on(this._element, M, this._config.selector, (H) => {
              const U = this._initializeOnDelegatedTarget(H);
              U._activeTrigger[H.type === "focusin" ? x : R] = !0, U._enter();
            }), r.on(this._element, W, this._config.selector, (H) => {
              const U = this._initializeOnDelegatedTarget(H);
              U._activeTrigger[H.type === "focusout" ? x : R] = U._element.contains(H.relatedTarget), U._leave();
            });
          }
        this._hideModalHandler = () => {
          this._element && this.hide();
        }, r.on(this._element.closest(C), P, this._hideModalHandler);
      }
      _fixTitle() {
        const c = this._element.getAttribute("title");
        c && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", c), this._element.setAttribute("data-bs-original-title", c), this._element.removeAttribute("title"));
      }
      _enter() {
        if (this._isShown() || this._isHovered) {
          this._isHovered = !0;
          return;
        }
        this._isHovered = !0, this._setTimeout(() => {
          this._isHovered && this.show();
        }, this._config.delay.show);
      }
      _leave() {
        this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(() => {
          this._isHovered || this.hide();
        }, this._config.delay.hide));
      }
      _setTimeout(c, E) {
        clearTimeout(this._timeout), this._timeout = setTimeout(c, E);
      }
      _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(!0);
      }
      _getConfig(c) {
        const E = s.getDataAttributes(this._element);
        for (const M of Object.keys(E))
          h.has(M) && delete E[M];
        return c = {
          ...E,
          ...typeof c == "object" && c ? c : {}
        }, c = this._mergeConfigObj(c), c = this._configAfterMerge(c), this._typeCheckConfig(c), c;
      }
      _configAfterMerge(c) {
        return c.container = c.container === !1 ? document.body : a.getElement(c.container), typeof c.delay == "number" && (c.delay = {
          show: c.delay,
          hide: c.delay
        }), typeof c.title == "number" && (c.title = c.title.toString()), typeof c.content == "number" && (c.content = c.content.toString()), c;
      }
      _getDelegateConfig() {
        const c = {};
        for (const [E, M] of Object.entries(this._config))
          this.constructor.Default[E] !== M && (c[E] = M);
        return c.selector = !1, c.trigger = "manual", c;
      }
      _disposePopper() {
        this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
      }
      // Static
      static jQueryInterface(c) {
        return this.each(function() {
          const E = B.getOrCreateInstance(this, c);
          if (typeof c == "string") {
            if (typeof E[c] > "u")
              throw new TypeError(`No method named "${c}"`);
            E[c]();
          }
        });
      }
    }
    return a.defineJQueryPlugin(B), B;
  });
})(qe);
var Oi = qe.exports;
const Si = /* @__PURE__ */ Nt(Oi);
export {
  Di as C,
  Ci as M,
  Si as T,
  Ni as a,
  xi as v
};
